import { get, post, handleErrors, deleteRequest, put } from "./requests";
import { loadQuestions } from "../redux/actions/questionsActions";
import { Store } from "../redux/store";
import { URL_BASE } from "./constants";
import arrayMove from "array-move";

async function getQuestionsByCategory(idSubcategory) {
    const url = `${URL_BASE}/questions/subcategory/${idSubcategory}`;
    const questionsPayload = await get(url);
    Store.dispatch(loadQuestions(questionsPayload.data));
    return questionsPayload.data;
}

async function changeQuestionOrder(prevIndex, newIndex, id) {
    const questions = Store.getState().questionState.questions;
    const newOrder = arrayMove(questions, prevIndex, newIndex);
    Store.dispatch(loadQuestions(newOrder));

    const changeOrder = newOrder.map((question, i) => ({
        idQuestion: question.id,
        newOrdenation: i + 1
    }));

    await put(`${URL_BASE}/questions/order`, changeOrder, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
}

async function createQuestion(query, idSubcategory) {
    const ordenation = Store.getState().questionState.questions.length + 1;
    const question = {
        query,
        ordenation,
        idSubcategory
    }

    await post(`${URL_BASE}/questions`, question, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });

    getQuestionsByCategory(idSubcategory);
}

async function changeQuestion(id, query) {
    const question = Store.getState().questionState.questions.filter((question) => question.id === id)[0];
    question.query = query;
    delete question.ordenation;
    await put(`${URL_BASE}/questions`, question, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
}

async function deleteQuestion(questionId) {
    await deleteRequest(`${URL_BASE}/questions/${questionId}`, null, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    const { idSubcategory } = Store.getState().questionState.questions.filter((question) => question.id === questionId)[0];
    getQuestionsByCategory(idSubcategory);
}

export default {
    getQuestionsByCategory,
    changeQuestionOrder,
    createQuestion,
    changeQuestion,
    deleteQuestion
}